import { Typography } from '@mui/material';
import { ReactNode } from 'react';

export type MapEntityDrawerHeaderProps = {
  children: ReactNode;
};

export const MapEntityDrawerHeader = (
  props: MapEntityDrawerHeaderProps,
): JSX.Element => {
  const { children } = props;

  return (
    <Typography
      variant="h3"
      sx={{
        fontWeight: 'bold',
        overflow: 'hidden',
        pr: 4, // add padding to account for the close button
      }}
    >
      {children}
    </Typography>
  );
};
